"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var marker_rent_svg_1 = __importDefault(require("../../images/google/markers/marker-rent.svg"));
var marker_sell_svg_1 = __importDefault(require("../../images/google/markers/marker-sell.svg"));
var marker_daily_rent_svg_1 = __importDefault(require("../../images/google/markers/marker-daily_rent.svg"));
var API_KEY = process.env.MIX_GOOGLE_API_KEY;
var PLACES_API_URL_PREFIX = process.env.MIX_PLACES_API_URL_PREFIX;
var MAP_LIBS = ['places', 'geometry'];
var GoogleGeocoding = {
    API_KEY: API_KEY,
    MAP_LIBS: MAP_LIBS,
    API_URL: PLACES_API_URL_PREFIX + "/geocode/json?key=" + API_KEY,
    API_AUTOCOMPLETE_PLACES_URL: PLACES_API_URL_PREFIX + "/place/autocomplete/json?key=" + API_KEY,
    CLUSTER_OPTIONS: {
        imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m', // so you must have m1.png, m2.png, m3.png, m4.png, m5.png and m6.png in that folder
    },
    MAP: {
        DEFAULT_CENTER: {
            lat: 40.179188,
            lng: 44.499104,
        },
        ZOOM: 8,
        NO_CLICKABLE_ZOOM: 12,
        OPTIONS: {
            minZoom: 8,
            fullscreenControl: false,
            gestureHandling: 'cooperative',
        },
        CONTAINER_STYLE: {
            width: '100%',
            height: '100%',
        },
        TYPE_TO_MARKER: {
            daily_rent: marker_daily_rent_svg_1.default,
            sell: marker_sell_svg_1.default,
            rent: marker_rent_svg_1.default,
        },
        VIEW_BOX: {
            east: 46.7183967936157,
            north: 41.53073545869181,
            south: 39.7237947884598,
            west: 41.44238437296141,
        },
        ARMENIAN_COORDINATES: {
            east: 48.34803291247893,
            north: 41.63056381373115,
            south: 39.218135942408615,
            west: 42.420908889041435,
        },
    },
    // World coordinates clock wise
    WORLD_COORDINATES: [
        [-85.1054596961173, -180],
        [85.1054596961173, -180],
        [85.1054596961173, 180],
        [-85.1054596961173, 180],
        [-85.1054596961173, 0],
    ],
    POLYGON_STYLES: {
        strokeColor: '#0D8272',
        strokeOpacity: 1,
        strokeWeight: 2,
        fillColor: '#0D8272',
        fillOpacity: 0.35,
    },
};
exports.default = GoogleGeocoding;
